import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './PayrollCreateScreen';
import PayrollCreate from './PayrollCreateScreen';
import { StoreState } from 'src/store/reducers';
import { getFormValues } from 'redux-form';
import { getProvidersPayroll } from 'src/store/actions/payroll-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.payrolls.inProgress,
        providersPayroll: state.payrolls.providerPayload,
        valuesForm: getFormValues('payroll-form')(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getProvidersPayroll: (data: { dateFrom: string; dateTo: string }) => dispatch(getProvidersPayroll(data)),
    };
}

const PayrollCreateScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(PayrollCreate);

export default PayrollCreateScreen;
